// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"9d4dc971","238":"a1746231","422":"fb26ab4c","840":"d84d2a03","980":"473ad9e1"}[chunkId] + ".chunk.js";
};